import { partition } from 'es-toolkit';

/** The master account's own books ("Moje kancelář") first; everything else keeps the order it came in. */
export function ownBooksFirst<T>(items: readonly T[], isOwnBooks: (item: T) => boolean): T[] {
  const [ownBooks, clients] = partition(items, isOwnBooks);
  return [...ownBooks, ...clients];
}
